// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1QAa0"};